import {useIssueComments} from '../../../../stores/layout-selectors'
import {ForYouIssueCommentItem} from './issue-comments/ForYouIssueComment'

export function IssueComments() {
  const issueComments = useIssueComments()

  return (
    <>
      {issueComments.map(comment => (
        <ForYouIssueCommentItem key={comment.id} comment={comment} />
      ))}
    </>
  )
}
